import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AMBIANCE_IMAGES, generateAmbianceSVG, getAmbianceTemplates } from '../utils/ambianceTemplates';

const AmbianceCardModal = ({ onSend, onClose }) => {
  const { t } = useTranslation();
  const canvasRef = useRef(null);
const [currentSVG, setCurrentSVG] = useState('');
  const templates = getAmbianceTemplates(t);
  const [selectedTemplate, setSelectedTemplate] = useState(templates[0].id);
const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [message, setMessage] = useState('');
const [title, setTitle] = useState('');
const [finalTitle, setFinalTitle] = useState('');
//const [imageIndex, setImageIndex] = useState(0);
const [isSending, setIsSending] = useState(false);

  //const currentSVG = generateAmbianceSVG(selectedTemplate, title, message, t, selectedImageIndex);
useEffect(() => {
  const loadSVG = async () => {
    const svg = await generateAmbianceSVG(selectedTemplate, title, message, t, selectedImageIndex);
    setCurrentSVG(svg);
  };

  loadSVG();
}, [selectedTemplate, title, message, t, selectedImageIndex]);

useEffect(() => {
  setSelectedImageIndex(0);
}, [selectedTemplate]);

useEffect(() => {
  setFinalTitle(t(`ambiance_card.${selectedTemplate}`));
}, [selectedTemplate, t]);

  const handleSend = () => {
setIsSending(true);

    const svgWithSize = currentSVG.replace(
      '<svg',
      '<svg width="600" height="400"'
    );

    const blob = new Blob([svgWithSize], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const img = new Image();

    img.onload = () => {
      const canvas = canvasRef.current;
      const scale = 4; 
      canvas.width = 600;
      canvas.height = 400;

      const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.fillStyle = '#000000';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  //ctx.scale(scale, scale);
  //ctx.drawImage(img, 0, 0);
  ctx.drawImage(img, 0, 0, 600, 400); // ← dimensions explicites

  URL.revokeObjectURL(url); 

      canvas.toBlob((pngBlob) => {
       // const fileName = `ambiance-card-${selectedTemplate}-${Date.now()}.png`;

      //  const fileObj = new Blob([pngBlob], { type: 'image/png' });
      //  Object.defineProperty(fileObj, 'name', { value: fileName });

// imageIndex = l'index de l'image sélectionnée (0-4)
if (!pngBlob || pngBlob.size === 0) {
      console.error('❌ Canvas vide !');
      return;
    }
const fileName = `ambiance-card-${selectedTemplate}-${selectedImageIndex}-${Date.now()}.png`;
const fileObj = new Blob([pngBlob], { type: 'image/png' });
Object.defineProperty(fileObj, 'name', { value: fileName, writable: false });
Object.defineProperty(fileObj, 'lastModified', { value: Date.now(), writable: false });


        onSend(fileObj);
      });
    };

    img.src = url;
  };

  return (
    <div className="birthday-modal-overlay" onClick={onClose}>
      <div className="birthday-modal" onClick={e => e.stopPropagation()}>
	<button className="btn-close" onClick={onClose}>✕</button>
        <h3>🎴 {t('ambiance_card.title')}</h3>

        <div>
  {templates.map(tpl => (
    <button
      className={`style-btn ${selectedTemplate === tpl.id ? 'active' : ''}`}
      key={tpl.id}
      onClick={() => setSelectedTemplate(tpl.id)}
    >
      {tpl.label}
    </button>
  ))}
</div>

{/* 🎨 Sélecteur d’images */}
<div
  style={{
    display: 'flex',
    gap: '8px',
    overflowX: 'auto',
    padding: '8px 0',
    marginBottom: '10px'
  }}
>
  {(AMBIANCE_IMAGES[selectedTemplate] || []).map((img, index) => (
    <img
      key={index}
      src={`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/uploads/${img.file}`}
      onClick={() => setSelectedImageIndex(index)}
      style={{
        width: 70,
        height: 70,
        objectFit: 'cover',
        borderRadius: '10px',
        cursor: 'pointer',
        flexShrink: 0,
        border: selectedImageIndex === index
          ? '3px solid #fff'
          : '2px solid transparent',
        transform: selectedImageIndex === index ? 'scale(1.05)' : 'scale(1)',
        transition: '0.2s'
      }}
    />
  ))}
</div>
<input
  type="text"
  placeholder={t('ambiance_card.title_placeholder')}
  value={title}
  onChange={e => setTitle(e.target.value)}
  maxLength={30}
  style={{ width: '100%', marginBottom: '10px', marginTop: '10px' }}
/>
        <textarea
          value={message}
className="textarea"
          onChange={e => setMessage(e.target.value)}
          placeholder={t('ambiance_card.message_placeholder')}
style= {{ width: '100%', marginBottom: '10px' }}
maxLength={200}
        />

        <div dangerouslySetInnerHTML={{ __html: currentSVG }} />


        {/* Bouton envoyer */}
<div style={{ display: 'flex', gap:'20px', alignItems: 'center' }}>
<span>
        <button
          className="buttonFile1"
          onClick={handleSend}
disabled={isSending}
                  >
         {isSending ? '⏳' : '📤'} {t('ambiance_card.send')}
        </button>
</span>

{isSending && (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
    <div className="spinner"></div>
    <span style={{ fontSize: '0.9rem', color: '#007bff' }}>
      {t('discussion.moderate') || 'Envoi en cours...'}
    </span>
  </div>
)}
</div>


        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </div>
    </div>
  );
};

export default AmbianceCardModal;